/* Model */
class BankModel extends App.Models.BaseModel {
  modelUrl = 'Bank';
}

App.Models.Bank = BankModel;

/* Collection */
class BankCollection extends App.Collections.BaseCollection {
  url = 'Bank';
  model = App.Models.Bank;
}

App.Collections.Banks = BankCollection;

/* Router */
class BankRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'Bank';
      const model = App.Models.Bank;
      const collectionClass = App.Collections.Banks;

      super(entityName, model, collectionClass);
  }
}

App.Routers.Bank = BankRouter;